// Reusable premium background layers used behind sections.
const BgLayer = ({ variant = "grid", intensity = "normal" }) => {
    const strong = intensity === "strong";
    return (
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
            {(variant === "grid" || variant === "mesh") && (
                <div className={`absolute inset-0 hero-grid ${strong ? "opacity-70" : "opacity-40"}`} />
            )}
            {(variant === "mesh" || variant === "orbs") && (
                <>
                    <div className={`hero-orb w-[520px] h-[520px] bg-[#A100FF]/${strong ? 20 : 12} -top-32 -left-20`} />
                    <div className={`hero-orb w-[420px] h-[420px] bg-[#7B00CC]/${strong ? 20 : 12} top-20 -right-24`} />
                    <div className={`hero-orb w-[380px] h-[380px] bg-[#C266FF]/${strong ? 12 : 8} bottom-0 left-1/3`} />
                </>
            )}
            {variant === "circuits" && (
                <>
                    <svg
                        className="absolute inset-0 w-full h-full opacity-30"
                        preserveAspectRatio="none"
                        viewBox="0 0 800 600"
                        fill="none"
                    >
                        <defs>
                            <linearGradient id="cg" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#A100FF" stopOpacity="0.4" />
                                <stop offset="100%" stopColor="#C266FF" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                        <path d="M0 120 L200 120 L240 160 L520 160 L560 200 L800 200" stroke="url(#cg)" strokeWidth="1" fill="none" />
                        <path d="M0 260 L120 260 L160 300 L560 300 L600 340 L800 340" stroke="url(#cg)" strokeWidth="1" fill="none" />
                        <path d="M0 400 L340 400 L380 440 L800 440" stroke="url(#cg)" strokeWidth="1" fill="none" />
                        <circle cx="200" cy="120" r="3" fill="#C266FF" />
                        <circle cx="520" cy="160" r="3" fill="#C266FF" />
                        <circle cx="160" cy="300" r="3" fill="#C266FF" />
                        <circle cx="380" cy="440" r="3" fill="#C266FF" />
                    </svg>
                    <div className="hero-orb w-[420px] h-[420px] bg-[#A100FF]/12 top-20 -right-24" />
                </>
            )}
            {variant === "dots" && (
                <div
                    className="absolute inset-0 opacity-[0.08]"
                    style={{
                        backgroundImage:
                            "radial-gradient(circle, #C266FF 1px, transparent 1px)",
                        backgroundSize: "22px 22px",
                        maskImage:
                            "radial-gradient(ellipse 80% 60% at center, black 0%, transparent 75%)",
                        WebkitMaskImage:
                            "radial-gradient(ellipse 80% 60% at center, black 0%, transparent 75%)",
                    }}
                />
            )}
            {/* Subtle noise overlay for depth */}
            <div className="absolute inset-0 noise" />
        </div>
    );
};

export default BgLayer;
